<template>
    <div class="cube-provider">
        <slot :cubeApi="cubeApi" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { createCubeApi } from '@/plugins/cubejs';

export default {
    name: 'CubeProvider',
    props: {
        apiUrl: {
            type: String,
            required: false
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            cubeApi: null
        };
    },
    computed: {
        ...mapGetters({
            currentUser: 'user/currentUser'
        }),
        userToken() {
            return this.$store.state.user?.profile?.cubejsToken;
        }
    },
    watch: {
        userToken(newToken, oldToken) {
            if (newToken !== oldToken) {
                this.initializeCubeApi();
            }
        }
    },
    created() {
        this.initializeCubeApi();
    },
    methods: {
        initializeCubeApi() {
            this.cubeApi = createCubeApi(this.apiUrl, {
                token: this.userToken,
                ...this.options
            });
        }
    },
    provide() {
        return {
            cubeApi: this.cubeApi
        };
    }
};
</script>
